import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const errorClasses =
  "data-[error=true]:!border-intent-error-3 data-[error=true]:!border-1";

export const baseInputClasses =
  "cursor-text bg-interactive-surface-default border border-interactive-outline-default rounded-lg text-interactive-content-default text-sm hover:bg-interactive-surface-hover hover:border-interactive-outline-hover hover:text-interactive-content-hover focus:bg-interactive-surface-focus focus:border-interactive-outline-focus focus:text-interactive-content-focus focus:outline-none transition-colors duration-200 data-[populated=true]:text-interactive-content-populated data-[populated=true]:border-interactive-outline-populated data-[populated=true]:bg-interactive-surface-populated " +
  "disabled:cursor-default disabled:pointer-events-none " +
  "disabled:bg-interactive-surface-disabled " +
  "disabled:border-interactive-outline-disabled " +
  "disabled:hover:border-interactive-outline-disabled " +
  "disabled:text-interactive-content-disabled " +
  errorClasses;

export const getInputClasses = (fullWidth?: boolean, className?: string) => {
  return twMerge(
    clsx(
      baseInputClasses,
      "px-6 py-4 pr-12 min-w-3xs",
      { "w-full": fullWidth },
      className,
    ),
  );
};

export const getContainerClasses = (props: { nested?: boolean }) => {
  return twMerge(
    clsx(
      "mb-6 relative text-sm leading-[18px]",
      props.nested ? "mb-0" : "mb-6",
    ),
  );
};
